/* Se Vira — animações leves ao rolar; fora do banner inicial e das esteiras. */
(function () {
  'use strict';

  function setup() {
    var root = document.getElementById('MainContent');
    if (!root || typeof IntersectionObserver === 'undefined' ||
        document.documentElement.classList.contains('shopify-design-mode') ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var targets = [
      '.sw-cats .sw-head',
      '.sw-cats .sw-cat',
      '.sw-banner__content',
      '.sw-insta .sw-head',
      '.sw-insta .sw-insta__item',
      '.sw-insta .sw-center',
      '.sw-benefits--big .sw-benefit',
      '.resource-list__item',
      '.product-grid__item',
      '.section-resource-list__content h2',
      '.section-resource-list__content h3'
    ].join(',');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-sv-scroll-reveal', 'show');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

    function reveal(el) {
      el.setAttribute('data-sv-scroll-reveal', 'show');
      observer.unobserve(el);
    }

    function scan() {
      root.querySelectorAll(targets).forEach(function (el) {
        if (el.hasAttribute('data-sv-scroll-reveal')) return;
        var box = el.getBoundingClientRect();
        if (box.width === 0 || box.height === 0) return;

        // Nunca esconda itens ja visiveis na primeira pintura.
        if (box.top < window.innerHeight * 0.90 || box.bottom < 0) {
          el.setAttribute('data-sv-scroll-reveal', 'show');
          return;
        }

        // Pequeno escalonamento apenas entre itens do mesmo grupo.
        var parent = el.parentElement;
        if (parent && el.matches('.sw-cat,.sw-insta__item,.resource-list__item,.product-grid__item,.sw-benefit')) {
          var index = Array.prototype.indexOf.call(parent.children, el);
          el.style.setProperty('--sv-reveal-delay', ((index % 4) * 65) + 'ms');
        }
        el.setAttribute('data-sv-scroll-reveal', 'wait');
        observer.observe(el);
      });
    }

    scan();

    // Vitrines e filtros Shopify podem substituir cards via AJAX.
    var scheduled = false;
    var domObserver = new MutationObserver(function (mutations) {
      if (!mutations.some(function (m) { return m.addedNodes.length > 0; })) return;
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        scan();
      });
    });
    domObserver.observe(root, { childList: true, subtree: true });

    // Navegacao por teclado nao deve focar conteudo invisivel.
    root.addEventListener('focusin', function (event) {
      var el = event.target instanceof Element
        ? event.target.closest('[data-sv-scroll-reveal="wait"]') : null;
      if (el) reveal(el);
    });

    // Permite trocar para movimento reduzido sem elementos escondidos.
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var change = function () {
      if (!motion.matches) return;
      root.querySelectorAll('[data-sv-scroll-reveal="wait"]').forEach(reveal);
      observer.disconnect();
      domObserver.disconnect();
    };
    if (motion.addEventListener) motion.addEventListener('change', change);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
